import { NewCheckoutWrapper } from "../../components";

export default function NewCheckoutPage() {
  return <NewCheckoutWrapper />;
}
